// funciones.js
export const generarEdades = () => {
    return Array.from({ length: 100 }, (_, index) => index + 1);
  };

 export const generarSexos = () => {
  return [
    { valor: "M", etiqueta: "Masculino" },
    { valor: "F", etiqueta: "Femenino" },
    { valor: "O", etiqueta: "Otro" }
  ];
};


  export const generarGruposSanguineos = () => {
    return ["O-", "O+", "A-", "A+", "B-", "B+", "AB-", "AB+"];
  };